import type { EmailTemplateDocumentType } from './documentEmailTemplates';

export type DocumentEmailTemplatePayload = {
  subjectTemplate: string;
  bodyTemplate: string;
};

export async function fetchDocumentEmailTemplate(
  documentType: EmailTemplateDocumentType,
): Promise<DocumentEmailTemplatePayload> {
  const res = await fetch(
    `/api/settings/document-email-template?type=${encodeURIComponent(documentType)}`,
    { credentials: 'include' },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((data as { error?: string }).error || 'Vorlage konnte nicht geladen werden.');
  }
  return data as DocumentEmailTemplatePayload;
}

export async function saveDocumentEmailTemplate(
  documentType: EmailTemplateDocumentType,
  payload: DocumentEmailTemplatePayload,
): Promise<DocumentEmailTemplatePayload> {
  const res = await fetch(
    `/api/settings/document-email-template?type=${encodeURIComponent(documentType)}`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((data as { error?: string }).error || 'Speichern fehlgeschlagen');
  }
  return data as DocumentEmailTemplatePayload;
}
